import { SET_COMPLIANCE_FILTERS, RESET_COMPLIANCE_FILTERS } from "./complianceFiltersTypes";

const initialState = {
  complianceByType: {
    searchTerm: "",
    order: "asc",
    orderBy: "name",
    // "all" — every record, dated or not — matches StatusFilter.all and the
    // leading "All" filter pill, which is the page's default view.
    statusFilter: "all"
  }
};

const complianceFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPLIANCE_FILTERS: {
      const { viewType, filters } = action.payload;
      if (!viewType || !Object.prototype.hasOwnProperty.call(state, viewType)) return state;
      const current = state[viewType] || {};
      return {
        ...state,
        [viewType]: {
          ...current,
          ...filters
        }
      };
    }
    case RESET_COMPLIANCE_FILTERS: {
      const { viewType } = action.payload;
      if (!viewType || !Object.prototype.hasOwnProperty.call(state, viewType)) return state;
      const defaultState = initialState[viewType] || {};
      return {
        ...state,
        [viewType]: { ...defaultState }
      };
    }
    default:
      return state;
  }
};

export default complianceFiltersReducer;
